var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 25,
    viewBox: "0 0 13 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55263 0.0450497C7.14511 0.26498 6.15789 0.743944 5.34662 1.59924C4.66241 2.32257 4.23722 3.16808 3.99774 4.27752C3.90489 4.69783 3.89511 4.95198 3.87556 6.92648L3.85602 9.11602H1.92556H0V11.3398V13.5635L1.92068 13.5733L3.83647 13.588L3.85113 19.2915L3.8609 25H6.15789H8.45489V19.2818V13.5635H10.3609C11.4117 13.5635 12.2669 13.5586 12.2669 13.5489C12.3989 12.6594 12.8338 9.17956 12.8192 9.15023C12.8094 9.13068 11.8222 9.11602 10.6248 9.11602H8.45L8.46466 7.29303C8.47932 5.51402 8.48421 5.47004 8.59662 5.18657C8.82632 4.61475 9.30526 4.27263 10.0286 4.17977C10.2241 4.15533 10.9718 4.1309 11.6951 4.1309H13L12.9902 2.13685L12.9756 0.147684L12.3402 0.089035C11.2992 -0.00382423 9.04135 -0.0331497 8.55263 0.0450497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2b6d06a7d3215697acd37480a24ab1ca.svg";
export { ForwardRef as ReactComponent };